<div *ngIf="!isRecordAvailable" class="center">
    <span>
        <h6><b>Customer Not Added </b></h6>
    </span>
</div>

<div class="customer-grid-table" *ngIf="isRecordAvailable">
    <!-- <ng-container *ngIf="this.data"> -->
    <kendo-grid [kendoGridBinding]="data" [pageSize]="5" [sortable]="true" [pageable]="true" [loading]="isLoading"
        [reorderable]="true" [resizable]="true" [height]="300" [columnMenu]="{ filter: true }">
        <div class="flair-column"></div>

        <kendo-grid-column field="customerName" title="Customer Name" [width]="220">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{dataItem.customerName}}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="legalCustomerName" title="Legal Customer Name" [width]="220">
        </kendo-grid-column>

        <kendo-grid-column field="customerRefNumber" title="Customer ID" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>{{dataItem.customerRefNumber}}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="status" title="Status" [width]="160">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div kendoTooltip filter=".status-wrapper" [tooltipWidth]="200" position="left">
                    <div class="status-wrapper" [title]="dataItem.statusDescription">
                        <ng-container *ngIf="!dataItem.requestsAdditionalCreditInfo">
                            <span>{{dataItem.status}}</span>
                        </ng-container>

                        <ng-container *ngIf="dataItem.requestsAdditionalCreditInfo">
                            <span>{{dataItem.status}}</span>
                            <div class="action-required-button-wrapper">
                                <app-stateful-primary-button [text]="'Click Here'"
                                    colorCssClass="orange"></app-stateful-primary-button>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-template>
        </kendo-grid-column>


        <ng-template kendoGridDetailTemplate let-dataItem>
            <div class="extension-container">
                <div class="extention" *ngIf="dataItem.customerAddress">
                    <p>
                        <strong>IsFederal: </strong>{{ dataItem.customerAddress?.isFederal }}
                    </p>
                    <p>
                        <strong>Monthly Invoice Amount:</strong> ${{
                        dataItem.customerAddress?.monthlyInvoiceAmount
                        }}
                    </p>
                    <p>
                        <strong>Monthly Invoice Term:</strong>
                        {{ dataItem.customerAddress?.invoiceTerm }} days
                    </p>
                </div>
                <div class="extention" *ngIf="dataItem.customerAddress">
                    <p>
                        <strong>Billing Address: </strong>{{ dataItem.customerAddress?.billingAddress }}
                    </p>
                    <p>
                        <strong>Headquarter Address: </strong>
                        {{
                        (dataItem.customerAddress?.headquartersAddress )
                        ? dataItem.customerAddress?.headquartersAddress
                        : "N/A"
                        }}
                    </p>
                    <p style="display: flex;">

                    </p>
                </div>
            </div>
        </ng-template>
        <ng-template kendoGridDetailTemplate>
            <div class="k-loading-color"></div>
            <div class="loading-container">
                <kendo-loader type="converging-spinner" size="large"></kendo-loader>
            </div>
        </ng-template>
        <kendo-grid-messages noRecords=""> </kendo-grid-messages>
    </kendo-grid>
    <!-- </ng-container> -->
</div>